import React, { useState } from "react";
import { Modal } from "react-bootstrap";

import { IcBackPack } from "../../common/svg";

import before_trip from "../../../static/images/modal/before-trip/before-trip.png";
import before_trip_1 from "../../../static/images/modal/before-trip/before-trip-1.svg";
import before_trip_2 from "../../../static/images/modal/before-trip/before-trip-2.svg";
import before_trip_3 from "../../../static/images/modal/before-trip/before-trip-3.svg";
import before_trip_4 from "../../../static/images/modal/before-trip/before-trip-4.svg";
import before_trip_5 from "../../../static/images/modal/before-trip/before-trip-5.svg";

const ModalBeforeTrip = ({ show, onHide }) => {
	return (
		<Modal show={show} onHide={onHide} dialogClassName="modal-m modal-text modal-fix">
			<Modal.Header closeButton={true} closeLabel="" />
			<Modal.Body>
				<div className="modal-text-body">
					<img loading="lazy" className="banner-img" src={before_trip} />
					<div className="block-content">
						<p>
							Để chuẩn bị cho chuyến đi sắp tới được diễn ra thuận lợi, Mioto xin gửi đến bạn một số điểm lưu ý cần
							chuẩn bị, chi tiết như sau:
						</p>
					</div>
					<div className="before-trip">
						<img loading="lazy" src={before_trip_1} />
						<div className="block-content">
							<p className="fontWeight-8">SAU KHI ĐẶT XE / TRƯỚC NGÀY ĐI</p>
							<p className="text-primary fontWeight-7">Liên hệ chủ xe - Chuẩn bị giấy tờ</p>
							<ul>
								<li>
									Liên hệ xác nhận lại với chủ xe về lịch trình thuê xe, giấy tờ thuê xe, địa điểm giao nhận xe, các phụ
									phí thuê xe khác (trả xe trễ, phí vệ sinh nếu xe bẩn/có mùi).
								</li>
								<li>
									Chuẩn bị đầy đủ giấy tờ thuê xe theo như yêu cầu: GPLX và CCCD gắn chip (hoặc Passport); và tài sản
									thế chấp (tiền mặt/chuyển khoản cho chủ xe hoặc Xe máy kèm cà vẹt gốc).
								</li>
								<li>
									Nếu thay đổi kế hoạch thuê xe, bạn vui lòng hủy chuyến trong thời gian sớm nhất (trong vòng 1h sau khi
									đặt cọc hoặc &gt;7 ngày trước chuyến đi) để không bị tính/giảm phí hủy chuyến.
								</li>
							</ul>
						</div>
					</div>
					<div className="before-trip">
						<img loading="lazy" src={before_trip_2} />
						<div className="block-content">
							<p className="fontWeight-8">NHẬN XE</p>
							<p className="text-primary fontWeight-7">
								Kiểm tra xe - Chụp hình hiện trạng - Kí hợp đồng &amp; biên bản nhận xe
							</p>
							<ul>
								<li>Nhận xe đúng hẹn.</li>
								<li>
									Cùng chủ xe kiểm tra &amp; chụp hình tình trạng xe khi nhận: 10-15 hình ảnh nội thất, ngoại thất, công
									tơ mét, kim xăng… để hạn chế tranh chấp phát sinh khi hoàn trả xe.
								</li>
								<li>
									Lưu lại hình ảnh trên điện thoại hoặc lưu trực tiếp trên ứng dụng Mioto (tại phần Thông tin chuyến
									-&gt; Hình ảnh chuyến).
								</li>
								<li>Kí hợp đồng thuê xe.</li>
								<li>
									Kí biên bản bàn giao xe (ghi nhận tình trạng xe lúc bàn giao, công tơ mét, kim xăng, các vết trầy xước
									đã có trước đó, thông tin giấy tờ bàn giao và tài sản thế chấp).
								</li>
								<li>Kí 2 bộ, mỗi bên giữ lại 1 bộ.</li>
							</ul>
						</div>
					</div>
					<div className="before-trip">
						<img loading="lazy" src={before_trip_3} />
						<div className="block-content">
							<p className="fontWeight-8">TRONG LÚC THUÊ</p>
							<p className="text-primary fontWeight-7">Bảo hiểm thuê xe</p>
							<ul>
								<li>
									Nếu có sự cố trong quá trình sử dụng xe, bạn vui lòng thông báo sớm nhất cho chủ xe &amp; thông báo
									cho nhà bảo hiểm để ghi nhận sự vụ và được hỗ trợ kịp thời (nếu xe có hỗ trợ bảo hiểm thuê xe)
								</li>
							</ul>
						</div>
					</div>
					<div className="before-trip">
						<img loading="lazy" src={before_trip_4} />
						<div className="block-content">
							<p className="fontWeight-8">TRẢ XE</p>
							<p className="text-primary fontWeight-7">Kiểm tra xe - Kí biên bản trả xe</p>
							<ul>
								<li>
									Trả xe đúng hẹn (nếu cần phải trả xe trễ, bạn nên thông báo sớm với chủ xe để thỏa thuận &amp; chủ xe
									có thể chủ động sắp xếp cho các khách hàng sau đó).
								</li>
								<li>
									Kiểm tra tình trạng xe khi hoàn trả và kí biên bản bàn giao đã trả xe (khách thuê giữ lại 1 bản).
									Trường hợp xe gặp sự cố phát sinh phí sửa chữa, chủ xe và khách thuê cùng thương lượng và thỏa thuận
									trên tinh thần hợp tác.
								</li>
							</ul>
						</div>
					</div>
					<div className="before-trip">
						<img loading="lazy" src={before_trip_5} />
						<div className="block-content">
							<p className="fontWeight-8">…. CUỐI CÙNG</p>
							<p className="text-primary fontWeight-7">Hỗ trợ khách hàng từ Mioto</p>
							<ul>
								<li>
									Nếu gặp bất kì khó khăn nào trong suốt quá trình thuê xe, bạn vui lòng liên hệ Mioto tại 1900 9217
									(9AM-9PM), Mioto luôn bên cạnh để hỗ trợ bạn.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

const BeforeTrip = () => {
	const [show, setShow] = useState(false);

	const toggleShow = () => {
		setShow(!show);
	};

	return (
		<>
			<div className="before-trip">
				<div className="title">
					<div className="wrap-svg">
						<IcBackPack />
					</div>
					<p className="fontWeight-6">Chuẩn bị trước chuyến đi</p>
				</div>
				<p className="font-12 fontWeight-6 pointer" onClick={toggleShow}>
					Xem chi tiết
				</p>
			</div>
			<ModalBeforeTrip show={show} onHide={toggleShow} />
		</>
	);
};

export default BeforeTrip;
